module.exports = __webpack_public_path__ + "img/background-img.790fe935.png";